import { render, staticRenderFns } from "./topo.vue?vue&type=template&id=ff4a9132&scoped=true&"
import script from "./topo.vue?vue&type=script&lang=js&"
export * from "./topo.vue?vue&type=script&lang=js&"
import style0 from "./topo.vue?vue&type=style&index=0&id=ff4a9132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4a9132",
  null
  
)

export default component.exports